module.exports = __webpack_public_path__ + "img/dyyy_on.04d01f41.png";